import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/PublicLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import NextEncounter from "@/pages/NextEncounter";
import RSVP from "@/pages/RSVP";
import Memories from "@/pages/Memories";
import Palavra from "@/pages/Palavra";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminParticipants from "@/pages/admin/AdminParticipants";
import AdminDevotionals from "@/pages/admin/AdminDevotionals";
import AdminAnnouncements from "@/pages/admin/AdminAnnouncements";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminYouthList from "@/pages/admin/AdminYouthList";
import AdminYouthForm from "@/pages/admin/AdminYouthForm";
import AdminYouthDetail from "@/pages/admin/AdminYouthDetail";
import AdminAttendance from "@/pages/admin/AdminAttendance";
import AdminReports from "@/pages/admin/AdminReports";

const TOAST_OPTIONS = { style: { background: "#0B0F17", border: "1px solid rgba(30,144,255,0.3)", color: "#fff" } };

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors toastOptions={TOAST_OPTIONS} />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/proximo-encontro" element={<NextEncounter />} />
            <Route path="/confirmar-presenca" element={<RSVP />} />
            <Route path="/memorias" element={<Memories />} />
            <Route path="/palavra" element={<Palavra />} />
            <Route path="/sobre" element={<About />} />
            <Route path="/contato" element={<Contact />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<AdminDashboard />} />
            <Route path="eventos" element={<AdminEvents />} />
            <Route path="participantes" element={<AdminParticipants />} />
            <Route path="devocionais" element={<AdminDevotionals />} />
            <Route path="avisos" element={<AdminAnnouncements />} />
            <Route path="galeria" element={<AdminGallery />} />
            <Route path="jovens" element={<AdminYouthList />} />
            <Route path="jovens/novo" element={<AdminYouthForm />} />
            <Route path="jovens/:id" element={<AdminYouthDetail />} />
            <Route path="jovens/:id/editar" element={<AdminYouthForm />} />
            <Route path="presenca" element={<AdminAttendance />} />
            <Route path="relatorios" element={<AdminReports />} />
            <Route path="configuracoes" element={<AdminSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
